<script>
	import Dispatch from '../../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'
  import ThumbCenter from './ThumbCenter.svelte'
  import ThumbLeft from './ThumbLeft.svelte'
  import ThumbRight from './ThumbRight.svelte'
  import ShadowRight from './ShadowRight.svelte'

	let mouseStart = 0

  const scale = Dispatch.getState('view.scale')

  export let selected
  export let command
  let height = 30

</script>

<div 
  id='notbase' 
  class='absolute flex justify-center' 
  style={'left: ' + (($scale.windowWidth / $scale.songLength) * command.position) + 'px; '}
  on:click={e => {
    e.preventDefault(); e.stopPropagation()
  }}
  >
  {#if selected === parseInt(command.id)}
    <div class='w-100 absolute flex justify-center' style={'top:-30px'}>
      <div class='bg-white' style={'width: 3px; height:30px;'}>
      </div>
    </div>
  {/if}
  <!-- {#if command.type === 'spiral'}
    <ThumbLeft command={command} />
    <ThumbCenter command={command}/>
    <ThumbRight command={command}/>
  {/if} -->
  <ThumbLeft command={command} height={height} />
  <ThumbCenter command={command} height={height}/>
  <ThumbRight command={command} height={height}/>
  {#if command.type === 'spiral'}
    <ShadowRight command={command} height={height}/>
  {/if}
</div>

<style>
</style>